import { ButtonGroup as ChakraButtonGroup, forwardRef } from '@chakra-ui/react';
import type { ButtonGroupProps as ChakraButtonGroupProps } from '@chakra-ui/react';

import { DEFAULT_PROPS } from './const';
import type { ButtonSize } from './types';

const spacings: Record<string, string> = {
  lg: '0.75rem',
  md: '0.625rem',
  sm: '0.5rem',
} satisfies Record<ButtonSize, string>;

export type ButtonGroupProps = ChakraButtonGroupProps;

export const ButtonGroup = forwardRef<ButtonGroupProps, 'div'>(
  ({ size, children, ...restProps }, ref) => {
    const defaultedSize = size ?? DEFAULT_PROPS.size;

    return (
      <ChakraButtonGroup
        ref={ref}
        size={size}
        spacing={spacings[defaultedSize]}
        {...restProps}
      >
        {children}
      </ChakraButtonGroup>
    );
  },
);
ButtonGroup.displayName = 'ButtonGroup';
